import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureActivatedGuardWrapper} from '../guards/feature-activated/feature-activated.guard';
@Injectable({
  providedIn: 'root'
})
export class BackendVersionResolverService {
  constructor(
    protected featureActivatedGuardWrapper: FeatureActivatedGuardWrapper,
    protected router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    return this.featureActivatedGuardWrapper.isActivated('gung', '3.0.24');
  }
}
